import * as React from "react";

import "./browser-warning-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {fragments}     from "@Common/react/fragments";
import {Invoke}        from "@Common/react/invoke";
import {StorageState}  from "@Common/react/storage-state";
import {isIe}          from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {isMac}         from "@Common/ui-components/debug/is-mac";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const BrowserWarningModal = ({next: rootNext}) => cs(
    ["modalClosed", (_, next) => StorageState({
        key: "browserModalClosed",
        storage: sessionStorage,
        next,
    })],
    ["modalState", ({modalClosed}, next) => ModalService3({
        xdQaName: "Browser Warning Modal",
        rootNext: next,
        onPassiveClose: () => modalClosed.onChange(true),
        next: WarningModalContent,
    })],
    ({modalState, modalClosed}) => fragments(
        isIe() && !modalClosed.value && (
            Invoke({action: () => modalState.show()})
        ),

        rootNext({
            showing: modalState.showing,
        }),
    ),
);

const WarningModalContent = () => (
    <div className="browser-warning-modal-3de">
        <div className="browser-modal-title">Browser Upgrade Recommended</div>
        <p className={"browser-modal-description"}>
            We&apos;ve noticed your browser may not be fully compatible with our site.
        </p>
        <p className={"browser-modal-description"}>
            To enjoy the best experience on our platform, please consider transitioning to one of these free modern browsers.
        </p>
        <div className={"browser-options"}>
            <a className="browser-type" href="https://www.google.com/chrome/" target="_blank">
                <img className="browser-img" src={require("./browser-imgs/Chrome.png")} alt="Google Chrome"/>
                Google Chrome
            </a>
            <a className="browser-type" href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                <img className="browser-img" src={require("./browser-imgs/Firefox.png")} alt="Firefox"/>
                Firefox
            </a>

            {isMac() && (
                <a className="browser-type" href="https://support.apple.com/en-us/HT204416" target="_blank">
                    <img className="browser-img" src={require("./browser-imgs/Safari.png")} alt="Safari"/>
                    Safari
                </a>
            )}
        </div>
    </div>
);
